module.exports = __webpack_public_path__ + "img/40_38_087_360.cce191d9.jpg";